"use strict";

module.exports = {
  // Typically the object that was interacted with
  categories: {
    SIDEMENU: 'Sidemenu',
    HEADER: 'Header',
    HOME_NAV_BUTTONS: 'Home nav buttons',
    SEARCH: 'Search bar'
  },
  // The type of interaction
  actions: {
    NAVIGATE: 'navigate',
    SEARCH: 'search',
    STATUS_CHANGE: {
      REPORTS: 'report status change',
      OPEN_FINDINGS: 'open findings status change'
    }
  },
  // Useful for categorizing events
  labels: {
    HOME: 'Home',
    REPORTS: 'Reports',
    OPEN_FINDINGS: 'Open Findings',
    MANAGEMENT: 'Management',
    RESOURCES: 'Resources',
    SEARCH_BAR: {
      REPORTS: 'Reports search bar',
      OPEN_FINDINGS: 'Open findings search bar'
    },
    NO_SEARCH: 'Did not click search button'
  }
};